import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import clsx from "clsx";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import CssBaseline from "@material-ui/core/CssBaseline";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import InboxIcon from "@material-ui/icons/MoveToInbox";
import MailIcon from "@material-ui/icons/Mail";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import SearchIcon from "@material-ui/icons/Search";
import Badge from "@material-ui/core/Badge";
import AccountCircle from "@material-ui/icons/AccountCircle";
import NotificationsIcon from "@material-ui/icons/Notifications";
import MoreIcon from "@material-ui/icons/MoreVert";
import DeleteSweepIcon from "@material-ui/icons/DeleteSweep";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import axios from "axios";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import Popper from "@material-ui/core/Popper";
import Fade from "@material-ui/core/Fade";
import Paper from "@material-ui/core/Paper";
import Icon from "@material-ui/core/Icon";
import { NavLink } from "react-router-dom";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import Avatar from "@material-ui/core/Avatar";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import LocalMallIcon from "@material-ui/icons/LocalMall";
import AssessmentIcon from "@material-ui/icons/Assessment";
import SettingsIcon from "@material-ui/icons/Settings";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import ListAltIcon from "@material-ui/icons/ListAlt";
import ReceiptIcon from "@material-ui/icons/Receipt";
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";
import DynamicIcon from "../components/DynamicIcon";
import DescriptionIcon from "@material-ui/icons/Description";
import MyAccount from "../pages/Settings/MyAccount/MyAccount";
import * as MaterialDesign from "@material-ui/icons/";
import HomeIcon from "@material-ui/icons/Home";
import moment from "moment-timezone";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import {
  get_cookies,
  delete_all_cookies,
  isLoggedIn,
} from "../components/Cookies/Cookies";
import LoginMessageBox from "./MessageBox/LoginMessageBox";
// import { useIdleTimer } from 'react-idle-timer'

const drawerWidth = 300;


const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "space-between!important",
  },
  textHeader: {
    color: "black!important",
  },
  textNav: {
    color: "black!important",
  },
  textGray: {
    color: "gray!important",
  },

  hamburger: {
    color: "green!important",
  },
  borderRadius: {
    borderRadius: "0!important",
  },
  appBar: {
    backgroundColor: "white!important",
    borderRadius: "0!important",
    boxShadow: "none!important",
    borderBottom: "1px solid #0000!important",
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  hide: {
    display: "none",
  },
  drawer: {
    borderRadius: "0!important",
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  ModalLogin: {
    display: "flex",
    justifyContent: "center",
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    paddingLeft: "5!important",
    overflowX: "hidden",
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9) + 1,
    },
  },
  toolbar: {
    display: "flex",
    alignItems: "right",
    justifyContent: "space-between",
    padding: theme.spacing(2, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    marginBottom: "4rem!important",
  },
  AluAppBar: {
    justifyContent: "space-between!important",
  },
  AlluAppBarBottom: {
    bottom: "0!important",
    top: "auto!important",
  },
  toolbarBottom: {
    display: "flex",
    alignItems: "right",
    justifyContent: "space-between",
    padding: theme.spacing(2, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  toolbarBottomText: {
    color: " #484848!important",
    marginRight: "2rem",
    fontWeight: "400",
  },
  toolbarBottomTextMiddle: {
    color: " #484848!important",
    fontWeight: "400",
    display: "flex",
    justifyContent: "center",
  },
}));

export default function Layout({ children }) {
    const location = useLocation();
  let history = useHistory();
  let username = get_cookies("fullname");
  let position = get_cookies("userrole");
  let main_nav_json = get_cookies("main.nav.access")
    ? JSON.parse(get_cookies("main.nav.access"))
    : "";
  const classes = useStyles();
  const theme = useTheme();
  const [open, setOpen] = React.useState(true);
  const [openLoader, setOpenLoader] = React.useState(false);
  const [openM, setOpenM] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorEll, setAnchorEll] = React.useState(null);
  const [anchorElll, setAnchorElll] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
  const [openMyAccount, setOpenMyAccount] = useState(false);
  const [secondary, setSecondary] = React.useState(false);
  const isMenuOpen = Boolean(anchorEll);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const [placement, setPlacement] = React.useState();
  const [mainNavId, setMainNavId] = useState(
    get_cookies("main.nav.access")
      ? JSON.parse(get_cookies("main.nav.access"))
      : ""
  );
  const [hideText, setHideText] = useState(false);
  const [mainNavData, setMainNavData] = useState([]);
  const x = 0;
  useEffect(() => {
    setMainNavId(main_nav_json);
    getMainNavContents();
  }, []);

  useEffect(() => {
    //
    isLoggedIn();
  }, [x]);

  const bgColor = location.pathname === "/Dashboard" ? "#ffff" : "#fafafa";
  const getMainNavContents = async () => {
    await axios
      .get(process.env.REACT_APP_API_URL + "get_main_nav_data", {
        params: {
          main_nav_id: mainNavId, //pass the main_nav_id from cookies to get data from api param example: "1,2,3,4,5,6,7,8"
        },
      })
      .then(function (res) {
        //console.log(res.data.data);
        const findTruncate = res.data.data.find(
          (row) => row.main_nav_desc === "truncate"
        );
        setMainNavData(res.data.data);
        if (findTruncate) {
          setHideText(true);
        }
      })
      .catch(function (error) {
        // console.log(error);
      });
  };

  const handleClicks = (newPlacement) => (event) => {
    setAnchorElll(event.currentTarget);
    setOpenM((prev) => placement !== newPlacement || !prev);
    setPlacement(newPlacement);
  };

  const myAccount = () => {
    setOpenMyAccount(true);
    handleClose();
    //open modal
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleProfileMenuOpen = (event) => {
    setAnchorEll(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEll(null);
    handleMobileMenuClose();
  };

  const logout = () => {
    handleClose();
    delete_all_cookies();
  localStorage.setItem("logout", Date.now()); 
  localStorage.clear();
  sessionStorage.clear();
    history.replace("/login");
  };

  const handleLoader = () => {
    setOpenLoader(false);
  };
  const handleToggle = () => {
    setOpenLoader(!open);
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const [showMsgBox, setShowMsgBox] = useState(false);
  const [msgBoxContent, setMsg] = useState("empty");
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [msgType, setMsgType] = useState("success");

 
  const menuId = "primary-search-account-menu";

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleOnIdle = event => {
    localStorage.setItem('is_logout', true);
    logout();
	}
	
  // const { getRemainingTime, getLastActiveTime } = useIdleTimer({
	// 	timeout: 1000 * 60 * 60,
	// 	onIdle: handleOnIdle,
	// 	// onActive: handleOnActive,
	// 	// onAction: handleOnAction
	// })
  return (
    <div className={classes.root} style={{
    backgroundColor:
      window.location.pathname === process.env.REACT_APP_BASE_NAME+"/dashboard" ? "#fff" : "",
  }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: open,
        })}
      >
        <Toolbar className={classes.AluAppBar}>
          <IconButton
            style={{ color: "white!important" }}
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            className={clsx(
              classes.menuButton,
              open && classes.hide,
              classes.hamburger
            )}
          >
            <MenuIcon className={classes.hamburger} />
          </IconButton>
          <div className={classes.grow} />
          <div className={classes.accounts}>


            <IconButton
              edge="end"
              disableFocusRipple
              disableRipple
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleClicks("bottom-end")}
              color="inherit"
            >
              <AccountCircle />
              <Typography
                variant="subtitle1"
                noWrap
                className={classes.textHeader}
                style={{
                  marginLeft: "10px",
                }}
              >
                {username}
              </Typography>
            </IconButton>
          </div>
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          }),
        }}
      >
        <div className={classes.toolbar}>
          <img src={require("../logo.png")} alt="" style={{ width: "45px" }} />
          <Typography>JC Headquarters</Typography>

          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "ltr" ? (
              <ChevronLeftIcon />
            ) : (
              <ChevronRightIcon />
            )}
          </IconButton>
        </div>

        <List>
          <NavLink to="/dashboard" key="1" className={classes.textHeader}>
            <ListItem button key="1">
              <ListItemIcon>
                <DynamicIcon iconName="Home" />
              </ListItemIcon>
              <ListItemText primary="Dashboard" className={classes.textNav} />
            </ListItem>
          </NavLink>
          {mainNavData?.map((text, index) => (
            <NavLink
              to={text.main_nav_href}
              key={text.main_nav_id}
              className={classes.textHeader}
            >
              <ListItem button key={text}>
                <ListItemIcon>
                  <DynamicIcon iconName={text.icon} />
                </ListItemIcon>
                <ListItemText
                  primary={text.main_nav_desc}
                  className={classes.textNav}
                />
              </ListItem>
            </NavLink>
          ))}
        </List>
      </Drawer>
      {/* {console.log('2323',process.env.REACT_APP_BASE_NAME+"/dashboard")}
            {console.log('hh',window.location.pathname)} */}
      <main className={classes.content}   style={{
 
    backgroundColor:
      window.location.pathname === process.env.REACT_APP_BASE_NAME+"/dashboard" ? "#fff" : "",
  }}>
        <div className={classes.toolbar} />
        <div className={classes.ModalLogin}>
          <LoginMessageBox
            in={showMsgBox}
            content={msgBoxContent}
            type={msgType}
          />
        </div>
        {children}
      </main>
      <MyAccount
        openMyAccount={openMyAccount}
        setOpenMyAccount={setOpenMyAccount}
      />
      <Popper
        open={openM}
        anchorEl={anchorElll}
        placement={placement}
        transition
        style={{ zIndex: "9999" }}
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <Paper>
              <MenuItem onClick={myAccount}>My account</MenuItem>
              <MenuItem onClick={logout}>Logout</MenuItem>
            </Paper>
          </Fade>
        )}
      </Popper>
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, classes.AlluAppBarBottom, {
          [classes.appBarShift]: open,
        })}
      >
        <Toolbar className={classes.toolbarBottom}>
          <p className={classes.toolbarBottomText}>
            JCPADMIN | JC Headquarters &#169; 2022
          </p>
          <a target="_blank" href="https://cloudpanda.ph/">
            <p className={classes.toolbarBottomTextMiddle}>
              powered by: Cloud Panda
            </p>
          </a>
        </Toolbar>
      </AppBar>
    </div>
  );
}
